<template>
  <div class="dashboard-action-items">
    <div class="actions-header">
      <div class="actions-header-left">
        <v-icon small color="#9ca3af">mdi-format-list-checks</v-icon>
        <h3 class="actions-title">{{ $t('org-dashboard.action-items') }}</h3>
      </div>
    </div>
    <div class="actions-table-wrap">
      <table class="actions-table">
        <thead>
          <tr>
            <th>{{ $t('org-dashboard.severity') }}</th>
            <th>{{ $t('org-dashboard.asset-location') }}</th>
            <th>{{ $t('org-dashboard.issue') }}</th>
            <th>{{ $t('org-dashboard.duration') }}</th>
            <th class="text-right">{{ $t('org-dashboard.action') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, i) in items"
            :key="i"
            :class="'actions-row--' + item.severity"
          >
            <td>
              <span class="severity-badge" :class="'severity-badge--' + item.severity">
                {{ severityLabel(item.severity) }}
              </span>
            </td>
            <td>
              <div class="asset-name">{{ item.asset }}</div>
              <div class="asset-location">{{ item.location }}</div>
            </td>
            <td class="issue-text">{{ item.issue }}</td>
            <td class="duration-text">{{ item.duration }}</td>
            <td class="text-right">
              <v-btn x-small outlined @click="$emit('action', item)">
                {{ $t('org-dashboard.view') }}
              </v-btn>
            </td>
          </tr>
          <tr v-if="!items || items.length === 0">
            <td colspan="5" class="text-center pa-4">
              <span class="no-actions">{{ $t('org-dashboard.no-actions') }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DashboardActionItems',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    severityLabel(severity) {
      const map = {
        critical: this.$t('org-dashboard.severity-critical'),
        warning: this.$t('org-dashboard.severity-warning'),
        info: this.$t('org-dashboard.severity-info'),
      }
      return map[severity] || severity
    },
  },
}
</script>

<style lang="scss" scoped>
.dashboard-action-items {
  background: white;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.actions-header {
  padding: 16px;
  border-bottom: 1px solid #f3f4f6;
  background: rgba(#f9fafb, 0.5);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.actions-header-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.actions-title {
  font-size: 14px;
  font-weight: 700;
  color: #1f2937;
}

.actions-table-wrap {
  flex: 1;
  overflow-y: auto;
  padding: 8px;
}

.actions-table {
  width: 100%;
  text-align: left;
  border-collapse: collapse;

  thead {
    position: sticky;
    top: 0;
    z-index: 1;
    background: #f9fafb;

    th {
      font-size: 11px;
      color: #6b7280;
      font-weight: 500;
      padding: 10px 12px;
      border-bottom: 1px solid #e5e7eb;
      text-transform: uppercase;
      letter-spacing: 0.3px;
    }
  }

  tbody {
    tr {
      border-bottom: 1px solid #f3f4f6;
      transition: background-color 0.15s;

      &:hover {
        background: rgba(#fef2f2, 0.3);
      }
    }

    td {
      padding: 10px 12px;
      font-size: 13px;
    }
  }
}

.severity-badge {
  display: inline-flex;
  align-items: center;
  font-size: 11px;
  font-weight: 700;
  padding: 4px 8px;
  border-radius: 4px;

  &--critical {
    color: #dc2626;
    background: #fef2f2;
  }
  &--warning {
    color: #d97706;
    background: #fffbeb;
  }
  &--info {
    color: #2563eb;
    background: #eff6ff;
  }
}

.asset-name {
  font-weight: 600;
  color: #1f2937;
}

.asset-location {
  font-size: 11px;
  color: #6b7280;
}

.issue-text {
  color: #374151;
}

.duration-text {
  font-family: monospace;
  font-size: 12px;
  color: #4b5563;
}

.no-actions {
  color: #9ca3af;
  font-size: 13px;
}
</style>
